import { render, staticRenderFns } from "./ServicesArchives.vue?vue&type=template&id=380ddcca&scoped=true&"
import script from "./ServicesArchives.vue?vue&type=script&lang=js&"
export * from "./ServicesArchives.vue?vue&type=script&lang=js&"
import style0 from "./ServicesArchives.vue?vue&type=style&index=0&id=380ddcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ddcca",
  null
  
)

export default component.exports